import { getAuthTokenFromSessionStorage } from 'utils/common-services/sessionStorage.service'
import store from 'index'
import { startLoader } from 'redux-store/redux/slices/loader.slice'

export const requestHandler = (request) => {
  if (request?.handlerEnabled) {
    const authToken = getAuthTokenFromSessionStorage()
    if (authToken) {
      request.headers.Authorization = `Bearer ${authToken}`
    }
  }

  // Loader Logic to add loader
  if (request?.loader) {
    store.dispatch(startLoader(request.loader))
  }  
  
  const state = store.getState()
  const gamificationArgs = state?.gamification?.gamificationArgs
  const method = request?.method?.toLowerCase()

  if (gamificationArgs && method && method !== 'get' && method !== 'delete' && 
    typeof request?.data === 'object' && request.data !== null && !Array.isArray(request.data) &&
    !(request.data instanceof FormData)) {
    request.data = {
      ...request.data,
      gamificationArgs: {
        ...gamificationArgs
      }
    }
  }

  return request
}
